'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = order;

var _actions = require('../helpers/actions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var INITIAL_STATE = {};

function order() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case 'COUNTRY':
      return state;
    case 'COUNTRY_SUCCESS':
      return (0, _extends3.default)({}, state, action.result.country);
    case 'COUNTRY_FAILURE':
      return (0, _extends3.default)({}, state, { error: (0, _actions.serializableError)(action.error) });
    default:
      return state;
  }
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/reducers/country.js
// module id = 2527
// module chunks = 0